export const depositType = {
  FIXED: 'fixed-value',
  EQUAL_TO_FIRST_PAYMENT: 'equal-to-first-payment'
};
